
import Vue from 'vue'
import { OS_REFS, arrayRef } from '@/models/refs'

export default Vue.extend({
    name: 'OsSelector',
    props: ['values'],
    data() {
        return {
            selected: [],
            options: arrayRef(OS_REFS),
        }
    },
    mounted() {
        this.selected = this.values
    },
    methods: {
        change() {
            this.$emit('onChange', this.selected)
        },
    },
})
